import React from "react";
import { Helmet } from "react-helmet";

const Title: React.FC<{ value: string }> = ({ value }) => (
  // @ts-ignore – react-helmet types are incompatible with @types/react >=18
  <Helmet>
    <title>{value}</title>
  </Helmet>
);

export default Title;
